export const homeRenovationLogo = '/assets/images/home-renovation-logo.png';
